import React, { useState } from "react";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { changeMyPassword } from "../../services/users.service"; // ajusta el path si cambia
import { clearAuth, logout } from "../../services/authentication.service";

const ProfileChangePassword: React.FC = () => {
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const handleSave = async () => {
    setError(null);
    setSuccess(null);

    if (!newPassword || !confirmPassword) {
      setError("Completa todos los campos.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("La nueva contraseña y la confirmación no coinciden.");
      return;
    }

    if (newPassword.length < 12 || newPassword.length > 128 || !newPassword.trim()) {
      setError("Usa una contraseña de entre 12 y 128 caracteres.");
      return;
    }

    try {
      setLoading(true);

      // 🔽 Llamamos tu función real
      await changeMyPassword(newPassword);

      await logout();
      clearAuth();
      setSuccess("Contraseña actualizada. Vuelve a iniciar sesión.");
      setNewPassword("");
      setConfirmPassword("");
    } catch (e) {
      setError("No se pudo actualizar la contraseña. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <div className="max-w-md">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
          Perfil
        </h1>

        <div className="teamassess-form">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
            Cambiar contraseña
          </h2>

          <div className="space-y-5">
            <div>
              <label
                htmlFor="new-password"
                className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
              >
                Nueva contraseña
              </label>
              <Password
                inputId="new-password"
                autoComplete="new-password"
                promptLabel="Ingresa una contraseña"
                weakLabel="Débil"
                mediumLabel="Media"
                strongLabel="Fuerte"
                aria-invalid={!!error}
                aria-describedby={error ? "password-error" : undefined}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                toggleMask
                className="w-full"
                inputClassName="w-full"
              />
            </div>

            <div>
              <label
                htmlFor="confirm-password"
                className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
              >
                Confirmar nueva contraseña
              </label>
              <Password
                inputId="confirm-password"
                autoComplete="new-password"
                aria-invalid={!!error}
                aria-describedby={error ? "password-error" : undefined}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                feedback={false}
                toggleMask
                className="w-full"
                inputClassName="w-full"
              />
            </div>

            {error && (
              <p id="password-error" role="alert" className="ta-field-error">
                {error}
              </p>
            )}

            {success && (
              <p role="status" className="text-sm text-green-700 dark:text-green-300 mt-2">
                {success}
              </p>
            )}
            {success && <a href="/login">Iniciar sesión</a>}

            <div className="pt-3">
              <Button
                label={loading ? "Guardando..." : "Guardar cambios"}
                onClick={handleSave}
                disabled={loading}
                className="p-button-primary w-full sm:w-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileChangePassword;
